import type { BarcodeExtractionRuleUpsertRequest } from '@ulysses-inc/harami_api_client'

export type BarcodeSettingForm = {
  isEnabled: boolean
  startPosition: number
  length: number
}

export const parseBarcodeExtractionRule = ({
  isEnabled,
  startPosition,
  length,
}: BarcodeSettingForm): BarcodeExtractionRuleUpsertRequest | undefined =>
  isEnabled ? { startPosition, length } : undefined
